import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useSelectedTab(tabs: { value: string; path: string }[]) {
  const location = useLocation();

  const selectedTab = useMemo(() => {
    const lastSegment = location.pathname.replace(/\/+$/, '').split('/').pop();
    return tabs.find((tab) => tab.value === lastSegment)?.value ?? tabs[0].value;
  }, [location.pathname, tabs]);

  return selectedTab;
}
